import { useRef, useState } from "react";
import styles from "./player.module.css";
import { TbMusic, TbMusicOff } from "react-icons/tb";

function Player() {
  const audioRef = useRef(null);
  const [isPlaying, setIsPlaying] = useState(false);
  const [progress, setProgress] = useState(0);

  const togglePlay = () => {
    if (isPlaying) {
      audioRef.current.pause();
    } else {
      audioRef.current.play();
    }
    setIsPlaying(!isPlaying);
  };

  const handleTimeUpdate = () => {
    const current = audioRef.current.currentTime;
    const duration = audioRef.current.duration;
    setProgress((current / duration) * 100);
  };

  const handleSeek = (e) => {
    const value = e.target.value;
    const duration = audioRef.current.duration;
    audioRef.current.currentTime = (value / 100) * duration;
    setProgress(value);
  };

  return (
    <div className={styles.player}>
      <audio
        ref={audioRef}
        src="/music/calming-rain.mp3"
        onTimeUpdate={handleTimeUpdate}
      />

      <button className={styles.play_btn} onClick={togglePlay}>
        {isPlaying ? <TbMusic /> : <TbMusicOff />  }
      </button>

      <input
        type="range"
        className="progress"
        value={progress}
        onChange={handleSeek}
      />
    </div>
  );
}

export default Player;
